import { HomeMainCompProps } from "../../../components/home-main-comp/home-main.comp";
import coverImage from "../../../assets/images/covers/mini/as-dev.png";
/* IMAGE LIST */
import imgCLB from "../../../assets/images/image-list/developer-img-list/centre-la-bontE.png";
import imgPPC from "../../../assets/images/image-list/developer-img-list/ppc.png";
import imgZaka from "../../../assets/images/image-list/developer-img-list/zaka.png";
import imgFeno from "../../../assets/images/image-list/developer-img-list/feno.png";
import imgCLBMini from "../../../assets/images/image-list/developer-img-list/mini/centre-la-bontE.png";
import imgPPCMini from "../../../assets/images/image-list/developer-img-list/mini/ppc.png";
import imgZakaMini from "../../../assets/images/image-list/developer-img-list/mini/zaka.png";
import imgFenoMini from "../../../assets/images/image-list/developer-img-list/mini/feno.png";

/* ENGLISH */
export const developerCompEnglishData: HomeMainCompProps = {
  homeMainCompData: {
    label: "developer",
    title: "DEVELOPER",
    subtitle: "My career as",
    img: coverImage,
    button: [
      {
        label: "MORE",
        value: "more-dev",
      },
    ],
    text: `
    I am as competent on the client side as on the server side when developing software and web or mobile applications.
`,
    imgList: [
      {
        img: imgPPCMini,
        link: imgPPC,
        title: "Project design",
        text: `
        Being able to design projects is a major asset for a fullstack developer.`,
      },
      {
        img: imgZakaMini,
        link: imgZaka,
        title: "web Application",
        text: `
        The web application is the most dynamic and practical application.`,
      },
      {
        img: imgCLBMini,
        link: imgCLB,
        title: "desktop Application",
        text: `
        Software remains the most powerful digital tool to date`,
      },
      {
        img: imgFenoMini,
        link: imgFeno,
        title: "Mobile Application",
        text: `
        Smartphones have become almost indispensable in everyday life.`,
      },
    ],
  },
};

/* FRENCH */
export const developerCompFrenchData: HomeMainCompProps = {
  homeMainCompData: {
    label: "developer",
    title: "DEVELOPPEUR",
    subtitle: "Ma carrière en tant que",
    img: coverImage,
    button: [
      {
        label: "PLUS",
        value: "more-dev",
      },
    ],
    text: `
    Je suis aussi compétent du côté client que du côté serveur pour développer des logiciels et des applications web ou mobiles.
`,
    imgList: [
      {
        img: imgPPCMini,
        link: imgPPC,
        title: "Conception de project",
        text: `
        Etre capable de concevoir des projets est un atout majeur pour un développeur fullstack.`,
      },
      {
        img: imgZakaMini,
        link: imgZaka,
        title: "Application web",
        text: `
        L'application web est l'application la plus dynamique et la plus pratique.`,
      },
      {
        img: imgCLBMini,
        link: imgCLB,
        title: "Logiciel",
        text: `
        Les logiciels restent l'outil numérique le plus puissant à ce jour`,
      },
      {
        img: imgFenoMini,
        link: imgFeno,
        title: "Application mobile",
        text: `
        Les smartphones sont devenus presque indispensables dans la vie quotidienne.`,
      },
    ],
  },
};
